import { CommonModule } from '@angular/common';
import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputDateComponent } from './custom-input-date/custom-input-date.component';
import { CustomInputFileComponent } from './custom-input-file/custom-input-file.component';
import { CustomInputRadioComponent } from './custom-input-radio/custom-input-radio.component';
import { CustomInputSelectComponent } from './custom-input-select/custom-input-select.component';
import { CustomInputTextAddressComponent } from './custom-input-text-address/custom-input-text-address.component';
import { CustomInputTextComponent } from './custom-input-text/custom-input-text.component';


@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  declarations: [
    CustomInputTextComponent,
    CustomInputDateComponent,
    CustomInputFileComponent,
    CustomInputRadioComponent,
    CustomInputSelectComponent,
    CustomInputTextAddressComponent,
  ],
  exports: [
    CustomInputTextComponent,
    CustomInputDateComponent,
    CustomInputFileComponent,
    CustomInputRadioComponent,
    CustomInputSelectComponent,
    CustomInputTextAddressComponent,
  ]
})
export class CustomInputsModule {}
